import React from 'react';
import { Button } from '@fx-ui/fine-design';
import { Intl } from '../../constants';
import classNames from 'classnames';
import { openInNewTab } from '@libs/shared';
import { globalState } from '../../models';
import { getCorpContactUrl } from '@fx-ui/platform-sdk';

interface IContactsFooterProps {
    className?: string;
    style?: React.CSSProperties;
    url?: string;
}

/**
 * 在业务场景下的成员选择弹窗左下角显示的通讯录入口
 * 通讯录页内的弹窗不显示该入口
 *
 * @param props IContactsFooterProps
 */
const ContactsFooter: React.FC<IContactsFooterProps> = (props) => {
    const { className, style, url } = props;

    if (!globalState.hasContactPermission) {
        return null;
    }

    return (
        <Button
            className={classNames('fx-contacts-footer', className)}
            style={style}
            type="negative"
            onClick={() => {
                openInNewTab(url || getCorpContactUrl());
            }}
        >
            {Intl.get('contacts')}
        </Button>
    );
};

export default ContactsFooter;
